<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div v-if="spinner">
          <img src="img/icon/icons8-spinner.gif" alt="Bitte warten ..." />
        </div>
      </div>
    </div>
    <div class="row align-items-start pb-2">
      <div clas="col-12">
        <Grid
          ref="grid"
          :style="{ height: '500px' }"
          :data-items="filteredData"
          :columns="columns"
          :filterable="true"
          :filter="filter"
          :sortable="true"
          :sort="sort"
          @filterchange="filterChange"
          @sortchange="sortChange"
          :filter-cell-render="filterRender"
        >
          <template v-slot:cellEditTemplate="{ props }">
            <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
          </template>
          <template v-slot:actionColumn="{ props }">
            <td>
              <button
                type="button"
                @click.prevent="onActionClick(props.dataItem)"
                class="btn btn-outline-primary"
              >
                Details
              </button>
            </td>
          </template>
          <template v-slot:filterSlotTemplate="{ props }">
            <div>
              <input
                type="text"
                :value="props.value"
                @input="
                  (ev) => {
                    props.onChange({
                      operator: 'contains',
                      field: props.field,
                      value: ev.target.value,
                      syntheticEvent: ev,
                    });
                  }
                "
                style="width: 120px"
              />
              <button
                @click="
                  (ev) => {
                    props.onChange({
                      operator: '',
                      field: '',
                      value: '',
                      event: ev,
                    });
                  }
                "
              >
                Clear
              </button>
            </div>
          </template>
          <grid-toolbar>
            <button title="Neu" class="k-button k-primary" @click="insert">
              Neu
            </button>
          </grid-toolbar>
          <grid-norecords> Keine Daten vorhanden </grid-norecords>
        </Grid>
        <person
          v-if="personInEdit"
          :data-item="personInEdit"
          @save="save"
          @cancel="cancel"
        >
        </person>
      </div>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { filterBy, orderBy } from "@progress/kendo-data-query";
import { apiPost } from "@/services/api/fetchapi";
import custom from "@/components/Stammdaten/GridCommandCell.vue";
import person from "@/components/Stammdaten/People/Person.vue";

export default {
  name: "People",
  inheritAttrs: false,
  components: {
    Grid,
    custom,
    person,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
  },
  data: function () {
    return {
      personInEdit: undefined,
      spinner: false,
      customerLink: "-",
      filter: {},
      sort: [
        { field: "nameBereich", dir: "asc" },
        { field: "email", dir: "asc" },
      ],
      filteredData: [],
      originData: [],
      staticColumns: [
        { cell: "cellEditTemplate", width: "210px" },
        {
          field: "nameMandant",
          title: "Mandant",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "nameBereich",
          title: "Bereich",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "nutzerprofil",
          title: "Nutzerprofil",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "idPerson",
          title: "IdPerson",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkNutzerProfil",
          title: "fkNutzerProfil",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkBereich",
          title: "fkBereich",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkLandCodeTabelle",
          title: "fkLandCodeTabelle",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkSprachCodeTabelle",
          title: "fkSprachCodeTabelle",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkErreichbarkeitCodeTabelle",
          title: "fkErreichbarkeitCodeTabelle",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkAnredeCodeTabelle",
          title: "fkAnredeCodeTabelle",
          filterable: false,
          hidden: true,
        },
        {
          field: "fkGeraetMobileEinheit",
          title: "fkGeraetMobileEinheit",
          filterable: false,
          hidden: true,
        },
        {
          field: "email",
          title: "Email",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "organisationBezeichnung",
          title: "Organisation",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "firma",
          title: "Firma",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "nachname",
          title: "Nachname",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "vorname",
          title: "Vorname",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "strasseUndNummer",
          title: "StrasseUndNummer",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "pLZ",
          title: "PLZ",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "ort",
          title: "Ort",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "adresszusatz",
          title: "Adresszusatz",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "bemerkung",
          title: "Bemerkung",
          filterable: false,
          hidden: true,
        },
        {
          field: "kundenLink",
          title: "Kunden-Link",
          width: "180px",
          filterable: false,
          hidden: false,
          cell: "actionColumn",
        },
        {
          field: "bestellNummer",
          title: "BestellNummer",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "rechnungsNummer",
          title: "RechnungsNummer",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "telFixnetPrivat",
          title: "TelFixnetPrivat",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "telSIP",
          title: "TelSIP",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "telFax",
          title: "TelFax",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "telMobil",
          title: "TelMobil",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "telFixnetGesch",
          title: "TelFixnetGesch",
          filterCell: "filterSlotTemplate",
          width: "180px",
        },
        {
          field: "nutzungStart",
          title: "NutzungStart",
          filterable: false,
          hidden: true,
        },
        {
          field: "nutzungEnde",
          title: "NutzungEnde",
          filterable: false,
          hidden: true,
        },
        {
          field: "datumZeitLetzteAenderung",
          title: "DatumZeitLetzteAenderung",
          filterable: false,
          hidden: true,
        },
        {
          field: "datumZeitErzeugung",
          title: "DatumZeitErzeugung",
          filterable: false,
          hidden: true,
        },
        {
          field: "erreichbarkeit",
          title: "Erreichbarkeit",
          filterable: false,
          hidden: true,
        },
        {
          field: "logistikStatus",
          title: "LogistikStatus",
          filterable: false,
          hidden: true,
        },
        {
          field: "istAlarmAus",
          title: "IstAlarmAus",
          filterable: false,
          hidden: true,
        },
        {
          field: "alarmMelodie",
          title: "AlarmMelodie",
          filterable: false,
          hidden: true,
        },
      ],
    };
  },
  computed: {
    columns() {
      return [...this.staticColumns];
    },
  },
  methods: {
    onActionClick(item) {
      try {
        console.log("");
      } catch (e) {
        console.log(e);
      }
    },

    filterChange: function (ev) {
      if (ev.filter == null || ev.filter.filters[0].value.length >= 2) {
        this.filter = ev.filter;
        this.filteredData = filterBy(this.originData, this.filter);
      }
    },

    filterRender: function (h, defaultRendering, props, change) {
      return defaultRendering;
    },

    sortChange: function (e) {
      this.sort = e.sort;
      this.filteredData = orderBy(this.originData, this.sort);
    },

    async getData() {
      try {
        this.spinner = true;
        const temp = await apiPost("ComponentView/getPeople", {
          userId: this.$store.getters["userstore/getUser"],
        });
        this.filteredData = temp.map((item) => {
          return { ...item };
        });
        this.originData = temp.map((item) => {
          return { ...item };
        });
      } catch (e) {
        console.log(e);
      }

      try {
        this.filteredData = filterBy(this.originData, this.filter);
      } catch (e) {
        console.log(e);
      }

      this.spinner = false;
    },
    edit(dataItem) {
      this.personInEdit = this.clonePerson(dataItem);
    },
    remove(dataItem) {
      this.products = this.filteredData.filter(
        (p) => p.idPerson !== dataItem.idPerson
      );
    },
    save() {
      const dataItem = this.personInEdit;
      const people = this.filteredData.slice();
      const isNewPerson = dataItem.idPerson === undefined;

      if (isNewPerson) {
        people.unshift(this.newPerson(dataItem));
      } else {
        const index = people.findIndex((p) => p.idPerson === dataItem.idPerson);
        people.splice(index, 1, dataItem);
      }

      this.filteredData = people;
      this.personInEdit = undefined;
    },
    cancel() {
      this.personInEdit = undefined;
    },
    insert() {
      this.personInEdit = {};
    },
    dialogTitle() {
      return `${
        this.personInEdit.idPerson === undefined ? "Add" : "Edit"
      } person`;
    },
    clonePerson(person) {
      return Object.assign({}, person);
    },

    newPerson(source) {
      const id =
        this.people.reduce(
          (acc, current) => Math.max(acc, current.idPerson || 0),
          0
        ) + 1;
      const newPerson = {
        idPerson: id,
        Vorname: "",
      };

      return Object.assign(newPerson, source);
    },
  },

  created() {
    this.spinner = true;
    this.getData();
  },
};
</script>

<style scoped language="scss">
.spinner__centered {
  position: fixed;
  left: 460px;
  top: 400px;
  z-index: 999;
}

.k-grid {
  font-size: 12px !important;
}
.select__max {
  max-width: 120px;
  min-width: 120px;
}

.label__adjust {
  margin-top: 5px;
}

.form-switch {
  border-radius: 2em;
  height: 25px;
  width: 25px;
}

.checkbox__adjust {
  margin-top: 3px;
}

.same__size {
  min-width: 120px;
}
</style>
